<template>
    <div class="text-img-video-section">
        <div class="container">
            <div class="row">
                <div :class="`${isAllWidth ? 'col-md-12': 'col-md-6'} ${isTextFirst ? '' : 'order-12'}`" data-aos="zoom-in">
                    <div class="info">
                        <div :class="`title ${titleColor}`" v-html="title" v-if="title"></div>

                        <h3 class="subtitle" v-html="subtitle" v-if="subtitle"></h3>

                        <div class="content" v-html="content"></div>
                    </div>
                </div>

                <div class="col-md-6" data-aos="zoom-in">
                    <div v-if="useImg" class="use-img">
                        <img :src="require(`../../../../../../public/static/img/mosaico_quem_somos.png`)" alt="" />
                    </div>

                    <div v-if="useVideo" class="use-video">
                        <iframe width="420" height="345" src="https://www.youtube.com/embed/tgbNymZ7vqY"></iframe>
                    </div>

                    <div v-if="useSecondText">
                        <div class="info">
                            <div :class="`title ${titleColor2}`" v-html="title2"></div>

                            <h3 class="subtitle" v-html="subtitle2" v-if="subtitle2"></h3>

                            <div class="content" v-html="content2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TextImgVideoSection',
    props: {
        isAllWidth: {
            type: Boolean,
            default: false
        },
        useImg: {
            type: Boolean,
            default: false
        },
        useVideo: {
            type: Boolean,
            default: false
        },
        textFirst: {
            type: Boolean,
            default: true
        },
        titleColor: {
            type: String,
            default: 'pink'
        },
        titleColor2: {
            type: String,
            default: 'pink'
        },
        title: {
            type: String,
            default: 'title'
        },
        title2: {
            type: String,
            default: 'title'
        },
        subtitle: {
            type: String,
            default: null
        },
        subtitle2: {
            type: String,
            default: null
        },
        content: {
            type: String,
            default: 'content'
        },
        content2: {
            type: String,
            default: 'content'
        },
        useSecondText: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            activeOption: 1,
            isImg: null,
            isVideo: null,
            defaultTitleColor: 'pink',
            isTextFirst: null,
            currentTitleColor: null
        }
    },
    mounted() {
        this.isImg = this.useImg
        this.isVideo = this.useVideo
        this.isTextFirst = this.textFirst
        this.currentTitleColor = ['pink', 'yellow', 'blue'].includes(this.titleColor)
            ? this.titleColor
            : this.defaultTitleColor
    }
}
</script>

<style scope src="./TextImgVideoSection-light-theme.css"></style>
<style scope src="./TextImgVideoSection-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/components/landing-page/text-img-video-section/TextImgVideoSection.vue